
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plaid-exchange/docs/reference",
      function () {
        return require("private-next-pages/plaid-exchange/docs/reference/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plaid-exchange/docs/reference"])
      });
    }
  